import { Trans } from "@lingui/macro";

import { PoolCards } from "./PoolCards";
import { useHistory } from "react-router-dom";

export function LiqiuditySection() {
  const totalLiquidity = "$20 000 000";
  const history = useHistory();

  const goToEarn = () => {
    history.push("/earn");
  };
  return (
    <section className="flex w-full bg-gray-1000 px-16 py-80 text-slate-900 sm:px-40 sm:py-[120px]">
      <div className="mx-auto flex w-[1200px] flex-col items-stretch justify-center overflow-hidden sm:items-start">
        {/*<h2 className="text-heading-2 mb-20 sm:mb-28">*/}
        {/*  {totalLiquidity} <Trans>in liquidity</Trans>*/}
        {/*</h2>*/}
        <h3 className="text-18 font-medium leading-heading-md -tracking-[0.896px] sm:text-[28px]">
          <Trans>Liquidity deposit is open NOW</Trans>
        </h3>
        <div className="mb-44 flex w-full flex-col items-stretch justify-between gap-24 lg:flex-row lg:items-center">
          <h3 className="text-18 font-medium leading-heading-md -tracking-[0.896px] sm:text-[28px]">
            <Trans>Earning real yield START</Trans>
          </h3>
          <button onClick={goToEarn} className="btn-landing rounded-8 bg-blue-200 px-16 py-12 text-16 text-white">
            <Trans>Start Earning</Trans>
          </button>
        </div>
        <div className="flex w-full flex-col gap-16 lg:flex-row">
          <PoolCards />
        </div>
      </div>
    </section>
  );
}
